import { render, staticRenderFns } from "./TicketSummaries.vue?vue&type=template&id=f1a3f342&"
import script from "./TicketSummaries.vue?vue&type=script&lang=js&"
export * from "./TicketSummaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports